import React, { useEffect, useState } from 'react';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import Button from '@components/common/Button';
import '../../ANC/Forms/View/index.css';
import NationalEmblem from '../../../../../assets/svg_main/national_emblem.svg';
import BadgesComponent from '@components/common/Badges';
import profilePic from '../../../../../assets/png/default_profile.png';
import BackArrowsvg from '../../../../../assets/svg_main/BackArrowIconSvg.svg';
import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import { desiredFormatDate, diffBetweenTwoDays, formatMonthText } from '@utils/commonUtils';
import { dateFormate, GENDER } from '@constants/index';
import ChildPNCView from '@pages/Beneficiary-block/WomenComponent/PNC/Child/ChildPNCView';
import useNavigateWithMenuItem from '@components/common/CustomHooks/useNavigateWithMenuItem';
import { RootState } from '@store/reducers';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getData } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import convertByteToImageURL from '@utils/convertByteToImageURL';
import { errorLogger } from '@utils/applicationLogUtils';
import dayjs from 'dayjs';
import HBYCServiceView from '../HBYCServiceView';
import NewBornView from '../ChildServices/NewBorn/NewBornView';
import { COMMON_CONSTANTS } from '../ChildServices/NewBorn/NewBornForm/NewBornConstants';
import ReferralChildView from '../../FacilityReferral/ReferralView/ReferralChildView';
import SickChildCareView from '../ChildServices/SickChildCare/SickChildCareView';

const ChildServiceView = () => {
    const params: any = useParams();
    const facilityDetails = useSelector((state: RootState) => state.beneficiary.viewAndEditFacilityDetails,);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);

    const [imageURL, setImageURL] = useState<string>('');
    const [currentTab, setCurrentTab] = useState('Overview');
    

    const navigateWithMenuItem = useNavigateWithMenuItem();

    const handleBack = () => {
      if(params.service === 'facility-referral') {
        navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Referral');
      } else {
        navigateWithMenuItem(`/beneficiaries/view/${childDetails?.benef_id}`, 'Services');
      }
    }

    useEffect(() => {
        fetchImage()
    }, []);

    const fetchImage = async () => {
        await getData<any>(`${endpoints.getImageByBeneficiaryID(childDetails?.benef_id)}`).then((res: any) => {
            if (res?.data[0]?.image) {
                const imageurl = convertByteToImageURL(res?.data[0]?.image?.data);
                setImageURL(imageurl);
            }
        }).catch((error: any) => {
            errorLogger(error?.response?.data || error?.response || error)
        })
    }

    const setCurrentForm = () => {
        let currForm;
        switch (params.service) {
          case 'pnc-child':
            currForm = <div><ChildPNCView /></div>
            break;
          case 'hbyc':
              currForm = <div><HBYCServiceView /></div>
              break;
          case 'new-born':
            currForm = <div><NewBornView /></div>
            break;
          case 'sick-child-care':
            currForm = <div><SickChildCareView /></div>
            break;
          case 'facility-referral':
            currForm = <div><ReferralChildView /></div>
        }
        return currForm;
      };

    const formatGenderText = (genderName: string): string => {
        return genderName === GENDER.FEMALE ? GENDER.FEMALE : GENDER.MALE;
    };

  return (
    <div>
        <div className="anc-view-wrapper referral-view">
          <header className="view-header">
            <div className="logo-wrapper">
              <NationalEmblem />
              <div className="name-wrapper">
                <div className="name-wrapper-title">
                  JANANI
                </div>
                <div className="name-wrapper-subtext">
                  Journey of Antenatal, Natal and Neonatal Integrated Care
                </div>
                <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
              </div>
            </div>
            <div className="view-route">
              <BreadcrumbComponent
                breadcrumbItemName={[
                  { value: '', label: 'Service Provider' },
                  { value: '', label: 'Beneficiary Profile' },
                ]}
              />
            </div>
          </header>
          <main className="view-content">
            <div className="view-profile-buttons">
              <div className="view-profile">
                <Button
                  onClick={handleBack}
                  disabled={false}
                  id=""
                  buttonName={''}
                  colorType={'verticalbackbutton'}
                  icon={<BackArrowsvg />}
                  iconPosition={'left'}
                />
                { 
                <div className='profile-pic'>
                     <img
                      className={`profile-picture ${childDetails?.is_dead ? 'black-white' : ''}`}
                      src={(imageURL && imageURL !== '') ? imageURL : profilePic}
                      alt='Profile Image'
                    />
                </div>}
                <div className="beneficiary-details">
                  <div className="name-type">
                    <div className='preg-badge'>
                      <div className='benf-name'>
                        {`${childDetails?.benf_name}`}
                      </div>
                      {!childDetails?.bal_abha_id && <BadgesComponent
                        className="beneficiary-status"
                        badgeName={'Temporary'}
                        variant={"warning"}
                        badgeType="case5"
                      />}
                      {childDetails?.is_dead && <BadgesComponent
                          className="beneficiary-status"
                          badgeName={"Deceased"}
                          variant={"danger"}
                          badgeType="case5"
                      />}
                    </div>
                  </div>
                  <div className="beneficiary-address-details">
                    <div className='gender-class'>
                        {`${formatMonthText(Math.floor(dayjs().diff(dayjs(childDetails?.dob), 'month', true)))}, ${formatGenderText(childDetails?.gender_name)}`}
                    </div>
                    {childDetails?.bal_abha_id ? (
                        <div>
                            Bal ABHA No : <span className="value-text">{childDetails?.bal_abha_id}</span>
                        </div>) : ('')}
                    {childDetails?.dob ? (
                        <div>
                            D.O.B : <span className="value-text">{desiredFormatDate(childDetails?.dob, dateFormate['dd/mm/yyy'])}</span>
                        </div>) : ('')}
                </div>
                </div>
              </div>
            </div>
            <div className="content">
              <LeftNavBar
                navItems={['Overview']}
                currentTab={currentTab}
                handleNavClick={setCurrentTab}
              />
              <div className={`tab-content`}>
                {params.service !== 'facility-referral' && (
                  <div className="overview_anc">
                    {params.service !== 'new-born' ? <BadgesComponent
                      className="over-badge"
                      badgeName="Facility Details"
                      variant="primary-1"
                      badgeType="case5"
                    />:
                    <div className="child-view-header-container">{COMMON_CONSTANTS.FACILITY_DETAILS}</div>
                    }
                    <div className="overview-details">
                      <div>
                        <label className="overview-details-label">
                          Facility Type
                        </label>
                        <div className="overview-details-value">
                          {facilityDetails?.facility_type_name}
                        </div>
                      </div>
                      <div>
                        <label className="overview-details-label">
                          Facility Name
                        </label>
                        <div className="overview-details-value">
                          {facilityDetails?.facility_name}
                        </div>
                      </div>
                      <div>
                        <label className="overview-details-label">
                          Health Provider Name
                        </label>
                        <div className="overview-details-value">
                          {facilityDetails?.healthProviderName}
                        </div>
                      </div>
                      <div>
                        <label className="overview-details-label">
                          Asha Name
                        </label>
                        <div className="overview-details-value">
                          {facilityDetails?.mobiliserName ? facilityDetails?.mobiliserName : '-'}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {setCurrentForm()}
              </div>
            </div>
          </main>
        </div>
    </div>
  )
}

export default ChildServiceView
